<template>
  <div class="ui-input">
    <div class="ui-input__field">
      <input
        :id="id"
        :type="type"
        class="ui-input__field__input"
        :class="{
          'ui-input__field__input--icon-left': icon && !reverse,
          'ui-input__field__input--icon-right': icon && reverse,
          'ui-input__field__input--error': error,
        }"
        :placeholder="hideLabel ? label : ' '"
        :value="inputValue"
        @input="onInput($event.target.value)"
        @blur.prevent="onBlur($event.target.value)"
        :autocomplete="autocomplete ? 'on' : 'off'"
        :disabled="disabled"
      />
      <span
        class="ui-input__field__icon backoffice-icons"
        :class="{
          'ui-input__field__icon--left': icon && !reverse,
          'ui-input__field__icon--right': icon && reverse,
          'ui-input__field__icon--error': error,
        }"
        v-if="icon"
      >
        {{ icon }}
      </span>
      <label
        :for="id"
        class="ui-input__field__label"
        :class="{
          'ui-input__field__label--icon-left': icon && !reverse,
          'ui-input__field__label--icon-right': icon && reverse,
          'ui-input__field__label--error': error,
          'ui-input__field__label--hidden': hideLabel,
        }"
      >
        {{ label }}
      </label>
    </div>
    <div class="ui-input__helper" :class="{ 'ui-input__helper--error': error }">
      <slot>{{ helper }}</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UiInput',
  model: {
    prop: 'inputValue',
  },
  props: {
    inputValue: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    hideLabel: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: String,
      required: false,
      default: 'text',
    },
    icon: {
      type: String,
      required: false,
      default: '',
    },
    helper: {
      type: String,
      required: false,
      default: '',
    },
    reverse: {
      type: Boolean,
      required: false,
      default: false,
    },
    autocomplete: {
      type: Boolean,
      required: false,
      default: false,
    },
    error: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    onInput(value) {
      /**
       * Emitted when the value of the input changed.
       * @event input
       * @type {Event}
       */
      this.$emit('input', value)
    },
    onBlur(value) {
      /**
       * Emitted when input is blured.
       * @event blur
       * @type {Event}
       */
      this.$emit('blur', value)
    },
  },
}
</script>

<style lang="scss" scoped>
.ui-input {
  &__field {
    position: relative;

    &__input {
      @include input;
    }

    &__label {
      @include input-label;
    }

    &__icon {
      @include input-icon;
    }
  }

  &__helper {
    @include input-helper;
  }
}
</style>
